import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

const root = document.getElementById("root");
const app = <React.StrictMode><App /></React.StrictMode>;
const isInquiryPage = window.location.pathname.replace(/\/$/, "") === "/inquiry";
if (root.hasChildNodes() && !isInquiryPage) hydrateRoot(root, app);
else {
  if (isInquiryPage) root.replaceChildren();
  createRoot(root).render(app);
}
